export const isValidPhoneNumber = (phoneNumber) =>
    /^\d{7,}$/.test(phoneNumber.replace(/[\s()+\-\.]|ext/gi, ''));
